import { useRef, useState } from 'react';
import { FaTimes, FaYoutube } from 'react-icons/fa';
import styled from 'styled-components';
// import video from '../images/WhatsApp Video 2025-08-13 at 01.39.40.mp4';
import '../style/videoShow.css';

const VideoShow = () => {
    const [showModal, setShowModal] = useState(false);
    const videoRef = useRef(null);

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        if (videoRef.current) {
            videoRef.current.pause();
        }
    };

    return (
        <div className="videoShow">
            <div className="content">
                <button 
                    className="button-85" 
                    role="button"
                    onClick={handleOpenModal}
                >
                Watch Video  <span><FaYoutube /></span>
                </button>
            </div>

            {showModal && (
                <ModalOverlay onClick={handleCloseModal}>
                    <ModalContent onClick={(e) => e.stopPropagation()}>
                        <CloseButton onClick={handleCloseModal}>
                            <FaTimes />
                        </CloseButton>
                        <VideoContainer>
                            <video 
                                // ref={videoRef}
                                controls 
                                autoPlay 
                            >
                                <source 
                                    // src={video}
                                    type="video/mp4" 
                                />
                                Your browser does not support the video tag.
                            </video>
                        </VideoContainer>
                    </ModalContent>
                </ModalOverlay>
            )}
        </div>
    );
};

// Styled Components
const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    position: relative;
    width: 90%;
    max-width: 800px;
    max-height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const VideoContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    
    video {
        max-width: 100%;
        max-height: 90vh;
        border-radius: 8px;
        outline: none;
    }
`;

const CloseButton = styled.button`
    position: absolute;
    top: -40px;
    right: 0;
    background: transparent;
    border: none;
    color: white;
    font-size: 1.5rem;
    cursor: pointer;
    z-index: 1001;

    &:hover {
        color: #ff0000;
    }
`;

export default VideoShow;